import { useCustomSelector } from './useCustomSelector';
import { PROMOTIONS_CONFIGURATION_REDUCER } from '../constants';

import { TPromotionsConfigurationSelector, TEqualityFunction } from '../types';

export const usePromotionsConfigurationSelector = <TSelected>(
    selector: TPromotionsConfigurationSelector<TSelected>,
    equalityFn?: TEqualityFunction<TSelected>
) => {
    return useCustomSelector<TSelected, typeof PROMOTIONS_CONFIGURATION_REDUCER>(
        PROMOTIONS_CONFIGURATION_REDUCER, selector, equalityFn);
};
